// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 15,
    marginTop: 10,
    color: GlobalStyles.color.COLOR_GREY,
    height: 80,
    width: 260,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    paddingTop: 15,
    paddingBottom: 15,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  textTitle: {
    margin: 0,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_SECONDARY,
  },
});

export default styles;
